__turbopack_context__.v({
  "breakdownText": "styles-module__v5KI2G__breakdownText",
  "breakdownText--green": "styles-module__v5KI2G__breakdownText--green",
  "breakdownText--grey": "styles-module__v5KI2G__breakdownText--grey",
  "breakdownTextSmall": "styles-module__v5KI2G__breakdownTextSmall",
  "breakdownWrapper": "styles-module__v5KI2G__breakdownWrapper",
  "expandButton": "styles-module__v5KI2G__expandButton",
  "expandableRow": "styles-module__v5KI2G__expandableRow",
  "expanded": "styles-module__v5KI2G__expanded",
  "icon": "styles-module__v5KI2G__icon",
  "row": "styles-module__v5KI2G__row",
  "row--tax": "styles-module__v5KI2G__row--tax",
  "row--total": "styles-module__v5KI2G__row--total",
  "shippingOriginalPrice": "styles-module__v5KI2G__shippingOriginalPrice",
  "taxLearnMoreLink": "styles-module__v5KI2G__taxLearnMoreLink",
});
